const AreaHelper = {
  modifyData: ({ portfolio, benchmark, orig_portfolio } = []) => {
    let finalData = [];

    let max_length = Math.max(benchmark.length, portfolio.length);

    for (let i = 0; i < max_length; i++) {
      let obj = {};
      let date;

      if (benchmark.length > portfolio.length) {
        date = benchmark[i]["dt"];
        obj["x"] = date;
      } else {
        date = portfolio[i]["dt"];
        obj["x"] = date;
      }

      let port_filter = portfolio.filter((e) => e.dt == date);
      let benchmark_filter = benchmark.filter((e) => e.dt == date);
      let orig_portfolio_filter = [];

      obj["y1"] = benchmark_filter.length
        ? benchmark_filter[0]["drawdown"] * 1
        : 0;

      obj["y2"] = port_filter.length ? port_filter[0]["drawdown"] * 1 : 0;

      if (orig_portfolio) {
        orig_portfolio_filter = orig_portfolio.filter((e) => e.dt == date);

        obj["y3"] = orig_portfolio_filter.length
          ? orig_portfolio_filter[0]["drawdown"] * 1
          : 0;
      }
      finalData.push(obj);
    }

    return finalData;
  },
};

export default AreaHelper;



// WEBPACK FOOTER //
// ./src/components/d3Components/multiAreaChart/AreaChartWithAxis/areaChartHelper.js